<template>
  <div >
    <div class="row">
      <div class="col-9">
        <h4 class="float-left esep-blue-color font-weight-bold">{{$t('progress.successfullTrainings')}}</h4>
      </div>
      <div  class="col-3" >
        <b-select v-model="perPage" :options="pageOptions" class="float-right w-5">
        </b-select>
      </div>
      <!-- <label class="mx-auto my-auto font-weight-bold"><b-badge variant="primary" class="esep-blue-bg"><h5 class="my-auto">{{ this.orgMember.id }} - {{ this.orgMember.surName }} {{ this.orgMember.firstName }}</h5></b-badge></label> -->
      <div class="ml-auto col-2">
        <!-- <label class="mr-1 h7"> {{ $t("members-table.extract") }} </label>
        <b-button class="esep-blue-bg float-right">
          Excel
        </b-button> -->
      </div>
    </div>
    <b-table
      id="member-trainings-table"
      striped
      hover
      borderless
      :items="trainingsList"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >

     
      <template v-slot:empty="">
        <h6>{{ $t("memberTrainings.emptyTable") }}</h6>
      </template>
    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="member-trainings-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {prettifyDate} from "@/services/utils";

export default {
  name: 'MemberTrainingTable',
  computed: {
    rows() {
      let rows = 0
      if(this.trainingsList != null) {
        rows = this.trainingsList.length;
      }
      return rows;
    }
  },
  props: {
    orgMember: {
      type: Object
    },
    trainingsList: {
      type: Array
    }
  },
  data() {
    return {
      fields: [
        { key: "activity.module.title", label: "Εκπαίδευση",formatter:"prettifyNullActivity", sortable: true , sortByFormatted: true, thClass: 'text-left', tdClass: 'text-left'},
        { key: "activity.activityNo", label: "Αριθμός Εκπαίδευσης" , formatter: "prettifyActivityNo"},
        { key: "activity", label: "Αρχηγός Εκπαίδευσης", formatter: "getActivityLeader", thClass: 'text-left', tdClass: 'text-left'},
        { key: "issueDate", label: "Ημ. Έκδοσης Πτυχίου", formatter:"prettifyDate",sortable: true },
      ],
      sortBy: 'issueDate',
      sortDesc: true,
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        10,
        20,
        50
      ],
    };
  },
  methods: {
    prettifyDate (stringDate) {
      return prettifyDate(stringDate);
    },
    prettifyTitle (modTitle) {
      let title = null;
      if(modTitle == null || modTitle == undefined) {
        title = '-'
      } else {
        title = modTitle;
      }
      return title;
    },
    prettifyActivityNo (activityNo) {
      let no = null;
      if(activityNo == null) {
        no = '-'
      } else {
        no = activityNo;
      }
      return no;
    },
    getActivityLeader(activity) {
      this.$log.debug(activity)
      let leaderName;
      if (activity != null && activity.leaders != null && activity.leaders.length > 0) {
        activity.leaders.forEach(member => {
          if(member.position == 'LEADER' ) {
              leaderName = member.member.surName + ' ' + member.member.firstName;
          }
        });
      } else {
        leaderName = '-';
      }
      return leaderName;
    }
  }
};
</script>

<style >

.w-5 {
  width: 5rem;
}

</style>